interface GroupMapping<F extends string> {
  key: string
  values: { value: string; field: F }[]
}

export function createSettingsAdapter<F extends string>(
  groups: GroupMapping<F>[]
) {
  type Settings = Record<F, boolean>

  const toGroupedValues = (settings: Settings): Record<string, string[]> =>
    Object.fromEntries(
      groups.map(({ key, values }) => [
        key,
        values.filter(({ field }) => settings[field]).map(({ value }) => value)
      ])
    )

  const fromGroupedValues = (grouped: Record<string, string[]>): Settings => {
    const entries = groups.flatMap(({ key, values }) => {
      const selected = grouped[key] ?? []

      return values.map(
        ({ value, field }) => [field, selected.includes(value)] as const
      )
    })

    return Object.fromEntries(entries) as Settings
  }

  return { toGroupedValues, fromGroupedValues }
}
